/**
 * RemediationStepsList — Renders step-by-step remediation instructions as a numbered list.
 *
 * Each step is a complete sentence/instruction without code snippets.
 */

interface RemediationStepsListProps {
  steps: string[];
  className?: string;
}

export function RemediationStepsList({
  steps,
  className = "",
}: RemediationStepsListProps) {
  if (steps.length === 0) {
    return null;
  }

  return (
    <section className={`remediation-section ${className}`}>
      <h4>Remediation Steps</h4>
      <ol className="remediation-steps">
        {steps.map((step, idx) => (
          <li key={idx}>{step}</li>
        ))}
      </ol>
    </section>
  );
}
